import apisauce from 'apisauce';

function apisauseCreator(baseURL, headers, timeout) {
  return apisauce.create({
    baseURL,
    headers,
    timeout,
  });
}

export default apisauseCreator;
